import { createEventBus, removeEventBus } from '@/util'
import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import BoardListItem from '@board/components/List/BoardListItem.vue'
import api from '@board/api'
import * as accountTypes from '@account/store/types'
import { mapGetters } from 'vuex'
@Component({
    components: { BoardListItem },
    computed: {
        ...mapGetters({
            User: accountTypes.USER,
        })
    },
})
export default class ListContainer extends Vue {
    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    searchValue: string = ''
    boardList: article.Article[] = []
    pageNumber: number = 1
    loadMorePossible: boolean = true

    pageSize: number = 15 //한 페이지당 노출 수 2023-05-30
    totalCount: number = 0 //전체 숫자 2023-05-30 추가

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    User!: account.User

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    loadData() {
        var searchSet: article.SearchSet = {
            userCode: this.User.personCode,
            boardId: Number(this.$route.query.id),
            page: this.pageNumber,
            itemsPerPage: this.pageSize,
            searchField: this.searchValue ? 1 : 0,
            searchFieldValue: this.searchValue,
            prefaceId1: null,
            prefaceId2: null,
            sortField: 0,
            sortOrder: false,
            includeContent: false,
            useNotice: true
        }

        //추가 페이지 여부 확인 2023-05-30
        if(this.totalCount > 0){
            if (this.pageNumber > Math.ceil(this.totalCount/this.pageSize))
            {
                this.loadMorePossible = false
                return false
            }
        }

        api.article.getArticles(searchSet).then(res => {
            if (res.data.length) {
                this.totalCount = Number(res.totalCount || 0) //총 개수 2023-05-30 추가
                if (this.pageNumber > 1) {
                    this.boardList = [...(this.boardList || []), ...res.data]
                } else {
                    this.isloading(false)
                    this.boardList = res.data
                }
            } else {
                this.isloading(false)
                this.loadMorePossible = false
            }
        })
    }

    loadMore() {
        if (this.loadMorePossible) {
            this.pageNumber ++
            this.loadData()
        }
    }

    handleSearchRequest(keyword: string) {
        if (keyword) {
            this.searchValue = keyword
        } else {
            this.searchValue = ''
            this.$emit('searchEnd')
        }
        this.loadDataReset()
        this.loadData()
    }

    loadDataReset() {
        this.boardList = []
        this.pageNumber = 1
        this.loadMorePossible = true
    }

    @Watch('$route.query.id')
    onChangedMenuId() {
        this.loadDataReset()
        this.loadData()
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    created() {
        this.isloading(true)
        this.loadData()
        createEventBus(window, 'header-search', this.handleSearchRequest)
    }

    beforeDestroy() {
        removeEventBus(window, 'header-search', this.handleSearchRequest)
    }
}
